import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from "react";
import { useLoaderData } from 'react-router-dom';
import { Box } from '../../../components/design';
import { formatDate } from '../../../library/utils';
import DocumentsDownloader from '../../template/documentDownloader';
import styles from "./delivered.module.scss";

const DeliveryTrackingRow = ({ item ,onButtonSubmit}) => {
    return (
            <div className={styles.deliveryRow}>
                <div className="quantity">{item.quantity}</div>
                <div className="address">{item?.street_number},{item?.street},{item?.city}</div>
                <div>{item.ship_quantity}</div>
                <div><a href={item.tracking_url} target="blank" rel="noreferrer noopener">View</a></div>
                <div>{formatDate(item?.dispatch_date)}</div>
                <div>{formatDate(item.expected_date)}</div>
                <Button type="primary" onClick={onButtonSubmit}
                >View Proofs</Button>
            </div>
      
    )
}
DeliveryTrackingRow.propTypes = {
    item: PropTypes.object.isRequired,
    onButtonSubmit :PropTypes.func
}

const Delivered = () => {
    const {productionDetails} = useLoaderData()
    const [open,setOpen]=useState(false)
    const proofs = productionDetails?.item_delivery_address?.[0].delivery_proof
 
    return (
        <div className={styles.container}>
            <h3>Task For You</h3>
            <Box header={
                <div className={styles.deliveryRowHead}>
                    <div>Quantity</div>
                    <div>Delivery Address</div>
                    <div>Ship Quantity</div>
                    <div>Tracking URL</div>
                    <div>Expected Dispatch Date</div>
                    <div>Expected Delivery Date</div>
                    <div></div>
                </div>
            }>
                <DeliveryTrackingRow item={productionDetails.item_delivery_address?.[0]} onButtonSubmit={()=>{setOpen(true)}} />
            </Box>
           <Modal onCancel={() => {setOpen(false)}} footer={<Button onClick={() => {setOpen(false)}}>OK</Button>} title="Proofs of Delivery" open={open} width={1000}>
                {proofs?.length > 0 ? <h3>Vendor proof</h3> : <div></div>}
                <br />
                <div className={styles.proofBox}>
                    {!!proofs && proofs.map((proof) => {
                        return (
                          <DocumentsDownloader image={proof.url} name={proof.name} key={proof.url} project_id={productionDetails.project_id} item_id={productionDetails.id}/>
                        )})}
                </div>
                <p style={{paddingTop:"25px"}}><b>Comment :</b>{productionDetails?.item_delivery_address?.[0]?.delivery_proof_comment}</p>

            </Modal>
        </div>
    )
}

export default Delivered;
// import { Button, Modal, message } from 'antd';
// import PropTypes from 'prop-types';
// import React, { useEffect, useState } from 'react';
 //import { getDeliveredDetails, getDeliveryDetails } from "../../../api/vendor/vendorProduction";
// import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
// import styles from '../../../components/data/quotation/quotation-item.module.scss';
// import { getPreview } from '../../../library/constants';
// import { Server } from '../../../library/constants/server';
// const Delivered = ({ data }) => {
//     const [deliveredData, setDeliveredData] = useState(null)
//     const [open, setOpen] = useState(false);
//     const [deliveredProofs, setDP] = useState(null)
//     useEffect(() => {
//         async function getData() {
   //         const v = await getDeliveryDetails(data.id)
//             setDeliveredData(v)
//         }
//         getData()
//         //Runs only on the first render
//     }, []);
//     return <div className={styles.stepBox}>
//         <h3 style={{ 'textAlign': 'start' }}>Task for you</h3>
//         <div className={styles.message}>
//             <ul>
//                 <li>The Order has been delivered to the customer.</li>
//             </ul>
//             <table style={{ 'width': '100%' }}>
//                 <tbody>
//                     <tr>
//                         <td style={{ 'padding': '16px' }}>Quantity</td>
//                         <td>Delivery Address</td>
//                         <td>Ship Quantity</td>
//                         <td>Expected Dispatch Date</td>
//                         <td>Tracking URL</td>
//                         <td>Expected Delivery Date</td>
//                         <td></td>
//                     </tr>
//                     {deliveredData && deliveredData.map((value, index) => {
//                         return (
//                             <tr className={styles.ship} key={index}>
//                                 <td style={{ 'padding': '16px' }}>{value.quantity}
//                                 </td>
//                                 <td>{value.street_number},{value.street},{value.city}</td>
//                                 <td>{value.ship_quantity}</td>
//                                 <td>{value.dispatch_date}</td>
//                                 <td>{value.tracking_url}</td>
//                                 <td>{value.expected_date}</td>
//                                 <td>
//                                     <Button onClick={() => {
//                                         if (value.status == 4) {
//                                             handleViewProof(value.id)
//                                             setOpen(true)
//                                         }
//                                         else {
//                                             message.warning('Not Yet Delivered')
//                                         }
//                                     }} type="primary">  {value.status == 4 ? 'View Proofs' : 'Not Yet Delivered'}
//                                     </Button>
//                                 </td>
//                             </tr>
//                         )
//                     }
//                     )
//                     }
//                 </tbody>
//             </table>
//             {/* {deliveredData != null ?
//             <div>
//                 {deliveredData && deliveredData.map(({ url, name }) => (
//                     <div style={{'margin-bottom':'16px'}} >
                      
//                            <Image src={Server.BaseUrl + '/api/v1/' + url} height={120} width={130}  className={styles.imageBox}/>
                      
//                         <span className={styles.viewPDF}>
//                             <a href={Server.BaseUrl + '/api/v1/' + url} target="blank">
//                                 <Button onClick={() => {
//                                     console.log(Server.BaseUrl + '/api/v1/' + url);
//                                 }} icon={<FilePdfOutlined />}>View File</Button>
//                             </a>
//                         </span>
//                         <br />
//                     </div>
//                 ))}
//                 <br />
//                 <br />
//             </div> : <div></div>} */}
//         </div>
//         <br />
//         <br />
//     </div>
// }
// Delivered.propTypes = {
//     data: PropTypes.object.isRequired,
// }
// export default Delivered;
